/*
 Dependencies
 */

import {Module} from "wrapper6";
import {debounce} from "./../_utils";

var $ = jQuery;

export default class NewssliderModule extends Module {

    boot() {
        if ($('.news_slider').length === 0) {
            return false;
        }
    }

    ready(app) {

        var _ = this;

        $(document).on('click', '[data-slide]', function () {
            _.activateSlide($(this));
        });

    }

    activateSlide(ele) {
        var slider = ele.closest('.news_slider');
        slider.find('.slide_indicator').removeClass('active');
        ele.find('.slide_indicator').addClass('active');
        var slide = parseInt(ele.attr('data-slide'));
        var indexes = [];
        for (var i = 1; i <= 3; i++) {
            indexes[indexes.length] = (slide - 1) * 3 + i;
        }
        var selector = '[data-index=' + indexes.join('],[data-index=') + ']';
        slider.find('[data-index]').addClass('hidden');
        slider.find(selector).removeClass('hidden');
    }
}